import React from 'react';
export const CommunicationGap = () => {
  return;
};